import { createFileRoute } from '@tanstack/react-router'
import { FeatureBoard } from '@/pages/feature-board/FeatureBoard'

export const Route = createFileRoute('/(protected)/feature-board/')({
  component: FeatureBoard,
})
